// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hmZe3{padding:16px 8px}@media screen and (min-width:400px){.hmZe3{padding:24px 16px}}@media screen and (min-width:768px){.hmZe3{padding:0}}.i74vU{margin:0 -8px}._9KnkL{margin-bottom:16px}.HGQXC{padding:0;margin:0;list-style:none}.U1S02{margin-top:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": "hmZe3",
	"sliderMobile": "i74vU",
	"slider": "_9KnkL",
	"cards": "HGQXC",
	"card": "U1S02"
};
module.exports = ___CSS_LOADER_EXPORT___;
